import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[fieldGroupAnchor]',
    standalone: false
})
export class FieldGroupAnchorDirective {
  public viewContainerRef = inject(ViewContainerRef);
}
